// extracted by mini-css-extract-plugin
export default {"cols":"ContactForm-module__[local]___5mCAl"};